<h3 mat-dialog-title style="font-family: 'Open Sans', sans-serif;">Comparte RACC Infotransit</h3>
<div mat-dialog-content fxLayout="row wrap" fxLayoutAlign="space-around center" class="container">
    <a class="twitter-share-button share-button"
    href="https://twitter.com/intent/tweet?url=http://infotransit.racc.es&text=Visita%20RACC%20Infotransit"><img src="assets/img/twitter.png" width="48px" alt=""></a>
    <a href="https://www.facebook.com/sharer/sharer.php?u=http%3A%2F%2Finfotransit.racc.es%2F&amp;src=sdkpreparse" class="share-button">
        <img src="assets/img/facebook.png" width="48px" alt="">
    </a>
    <a href="mailto:?subject=RACC%20Infotransit&amp;body=Informació%20sobre%20trànsit%20a%20temps%20real.%20Visita%20http://infotransit.racc.es" class="share-button">
        <img src="assets/img/email.png" width="48px" alt="">
    </a>
</div>
<div mat-dialog-actions align="end">
    <button mat-button (click)="closeDialog()" color="accent"  i18n>Cerrar</button>
    <!--<a href=""><button mat-button (click)="send()">Enviar</button></a>-->
</div>
